function IconPlasticWaste({ size = "100%", fillColor = "none", strokeColor = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 57 57" fill={fillColor} xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_114_3838)">
        <g clip-path="url(#clip1_114_3838)">
          <path d="M47.4851 50.3114V6.19547C47.4851 4.9002 46.437 3.85205 45.1417 3.85205H40.1566C38.8614 3.85205 37.8132 4.9002 37.8132 6.19547V17.3927C37.8132 18.3983 36.8077 19.097 35.8703 18.7391L30.1353 16.5832C28.9764 16.1486 27.7067 16.1486 26.5478 16.5832L20.8128 18.7391C19.8754 19.0885 18.8699 18.3983 18.8699 17.3927V6.19547C18.8699 4.9002 17.8217 3.85205 16.5265 3.85205H11.5329C10.2376 3.85205 9.18945 4.9002 9.18945 6.19547V50.3114C9.18945 51.7771 10.3825 52.9701 11.8482 52.9701H44.8179C46.2836 52.9701 47.4766 51.7771 47.4766 50.3114H47.4851Z" stroke={strokeColor} stroke-width="1.7043" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M22.9844 37.3589C22.9844 37.3589 26.9895 51.9136 35.5707 52.9703" stroke={strokeColor} stroke-width="1.7043" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M15.1543 36.1147C15.1543 36.1147 15.9298 38.6712 18.0431 42.2247" stroke={strokeColor} stroke-width="1.7043" stroke-linecap="round" stroke-linejoin="round" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_114_3838">
          <rect width="56" height="56" fill={fillColor} transform="translate(0.433594 0.0986328)" />
        </clipPath>
        <clipPath id="clip1_114_3838">
          <rect width="40" height="50.8223" fill={fillColor} transform="translate(8.33594 3)" />
        </clipPath>
      </defs>
    </svg>
  )
};

export default IconPlasticWaste;